import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import { useMergeRefs } from '@floating-ui/react';
import { getVisuallyHiddenStyles } from '../../visually-hidden/helpers/get-visually-hidden-styles';
import Tooltip from '../../tooltip';
import Icon from '../../icon';
import Paragraph from '../../paragraph';
import { APPEARANCES as PARAGRAPH_APPEARANCES } from '../../paragraph/constants';
const VISUALLY_HIDDEN_STYLES = getVisuallyHiddenStyles();

const CheckboxControl = ({
  checked = undefined,
  inputRef = undefined,
  indeterminate = false,
  children,
  defaultChecked = undefined,
  disabled = false,
  id,
  name = undefined,
  onChange,
  tooltipProps = undefined,
  value,
  isLabelBold = true,
}) => {
  const internalRef = useRef(null);

  const ref = useMergeRefs([internalRef, inputRef]);

  useEffect(() => {
    if (internalRef.current) {
      internalRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const isMobile = bowser.mobile;
  const isTablet = bowser.tablet;
  const isTouchDevice = isMobile || isTablet;
  const isTooltipEnabled = tooltipProps && !isTouchDevice && !disabled;
  const tooltipAttributesForControl =
    (tooltipProps &&
      !isTouchDevice && {
        'data-tip': true,
        'data-for': tooltipProps.id,
      }) ||
    {};

  const classes = classNames('ws-ui-checkbox__control', {
    'ws-ui-checkbox__control--disabled': disabled,
  });
  const checkmarkClasses = classNames('ws-ui-checkbox__checkmark', {
    'ws-ui-checkbox__checkmark--with-label': children,
  });

  const labelAppearance = disabled
    ? PARAGRAPH_APPEARANCES.lowEmphasis
    : PARAGRAPH_APPEARANCES.highEmphasis;

  return (
    <React.Fragment>
      <label htmlFor={id} className={classes} {...tooltipAttributesForControl}>
        <input
          checked={checked}
          ref={ref}
          className="ws-ui-checkbox__input"
          defaultChecked={defaultChecked}
          disabled={disabled}
          id={id}
          name={name}
          onChange={onChange}
          style={VISUALLY_HIDDEN_STYLES}
          type="checkbox"
          value={value}
        />
        <div className={checkmarkClasses}>
          <div className="ws-ui-checkbox__checkmark-icon">
            <Icon glyph="check" type="inherit" size="100%" />
          </div>
        </div>
        <div className="ws-ui-checkbox__label">
          <Paragraph appearance={labelAppearance}>
            {isLabelBold ? <b>{children}</b> : children}
          </Paragraph>
        </div>
      </label>
      {isTooltipEnabled && <Tooltip {...tooltipProps} />}
    </React.Fragment>
  );
};

export default CheckboxControl;
